import { memo } from 'react';
import { getRandomDelay } from '@/modules/promo';
import type { FlyingElementSrc as FlyingElementType } from '../../types';

import { ScFlyingElement } from './styled';

interface FlyingElementProps {
  flyingElements?: FlyingElementType[];
  maxWidthMobile?: number;
}

export const FlyingElement = memo(
  ({ flyingElements, maxWidthMobile = 1300 }: FlyingElementProps) => (
    <>
      {flyingElements?.map((element, index) => (
        <ScFlyingElement
          className="flying-elements"
          delay={getRandomDelay(3, 5)}
          key={index}
          maxWidthMobile={maxWidthMobile}
          positionX={element.posX}
          positionXMob={element.posXMob}
          positionY={element.posY}
          positionYMob={element.posYMob}
          size={element.size}
          sizeMob={element.sizeMob}
          src={element.src}
        />
      ))}
    </>
  )
);
